import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, imageUrl, apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Upload, X } from "lucide-react";

export default function AdminCategories() {
    const qc = useQueryClient();
    const { data: cats = [] } = useQuery({ queryKey: ["admin-cats"], queryFn: async () => (await api.get("/categories")).data });
    const [editing, setEditing] = useState(null);
    const del = async (id) => { if (!window.confirm("¿Eliminar?")) return; await api.delete(`/categories/${id}`); toast.success("Eliminada"); qc.invalidateQueries({ queryKey: ["admin-cats"] }); qc.invalidateQueries({ queryKey: ["cats"] }); };
    const save = async (form) => {
        try {
            if (form.id) await api.put(`/categories/${form.id}`, form);
            else await api.post("/categories", form);
            toast.success("Guardada");
            qc.invalidateQueries({ queryKey: ["admin-cats"] });
            qc.invalidateQueries({ queryKey: ["cats"] });
            setEditing(null);
        } catch (e) { toast.error(apiErr(e)); }
    };
    return (
        <div>
            <div className="flex justify-between items-center mb-8">
                <h1 className="font-display text-3xl">Categorías</h1>
                <button onClick={() => setEditing({ name: "", image: "", gender: null })} className="btn-ink inline-flex items-center gap-2"><Plus className="w-4 h-4" />Nueva</button>
            </div>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
                {cats.map((c) => (
                    <div key={c.id} className="bg-white border border-sandLight rounded-lg overflow-hidden">
                        <div className="aspect-[4/3] bg-sandLight">{c.image && <img src={imageUrl(c.image)} className="w-full h-full object-cover" alt="" />}</div>
                        <div className="p-4 flex justify-between items-center">
                            <div><p className="font-medium">{c.name}</p><p className="text-xs text-ink/50">{c.gender || "Todos"}</p></div>
                            <div className="flex gap-1">
                                <button onClick={() => setEditing(c)} className="text-ink/60 hover:text-ink text-xs uppercase">Editar</button>
                                <button onClick={() => del(c.id)} className="text-terracotta"><Trash2 className="w-4 h-4" /></button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {editing && <CatModal cat={editing} onClose={() => setEditing(null)} onSave={save} />}
        </div>
    );
}

function CatModal({ cat, onClose, onSave }) {
    const [f, setF] = useState({ ...cat });
    const [up, setUp] = useState(false);
    const upload = async (e) => {
        const file = e.target.files?.[0]; if (!file) return;
        setUp(true);
        try { const fd = new FormData(); fd.append("file", file); const { data } = await api.post("/uploads", fd); setF({ ...f, image: data.url }); }
        catch (e) { toast.error(apiErr(e)); } finally { setUp(false); }
    };
    const inp = "w-full border border-sandLight bg-white rounded-md px-3 py-2 text-sm";
    return (
        <div className="fixed inset-0 bg-ink/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg max-w-md w-full">
                <div className="flex justify-between p-6 border-b border-sandLight"><h2 className="font-display text-2xl">Categoría</h2><button onClick={onClose}><X /></button></div>
                <div className="p-6 space-y-3">
                    <input placeholder="Nombre" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={inp} />
                    <select value={f.gender || ""} onChange={(e) => setF({ ...f, gender: e.target.value || null })} className={inp}>
                        <option value="">Todos</option><option>Hombre</option><option>Mujer</option><option>Unisex</option>
                    </select>
                    <div>
                        <p className="text-eyebrow mb-2">Imagen</p>
                        <div className="flex items-start gap-3">
                            {f.image && <img src={imageUrl(f.image)} alt="" className="w-24 aspect-square object-cover rounded" />}
                            <label className="flex-1 border-2 border-dashed border-sandLight rounded p-4 text-center cursor-pointer">
                                <input type="file" accept="image/*" onChange={upload} className="hidden" />
                                <Upload className="w-5 h-5 mx-auto text-ink/50" />
                                <p className="text-xs mt-1">{up ? "Subiendo..." : "Subir imagen"}</p>
                            </label>
                        </div>
                        <input placeholder="O pegá URL" value={f.image || ""} onChange={(e) => setF({ ...f, image: e.target.value })} className={`${inp} mt-2`} />
                    </div>
                </div>
                <div className="p-6 border-t border-sandLight flex justify-end gap-3">
                    <button onClick={onClose} className="btn-outline">Cancelar</button>
                    <button onClick={() => onSave(f)} className="btn-ink">Guardar</button>
                </div>
            </div>
        </div>
    );
}
